module.exports = __webpack_public_path__ + "img/nbus_box_2-3.0078e138.jpg";